<template>
  <page-loader v-if="loadingStatus == 'loading'" />
  <div class="contain-section" v-else-if="introduction">
    <div class="row">
      <div class="col-sm-12 col-md-7 col-lg-8">
        <div class="inner-box">
          <div class="banner-box">
            <img :src="introduction &&
              introduction?.main_image &&
              introduction?.main_image.length > 0
              ? introduction.main_image[0].url
              : ''
              " alt="Logo" />
          </div>
          <div class="inner-content">
            <h3>{{ introduction ? introduction.heading : "" }}</h3>
            <div v-html="introduction ? introduction.text : ''"></div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-5 col-lg-4">
        <div class="right-bar">
          <!-- <div class="unlock-section">
            <div class="img">
              <img
                :src="
                  introduction &&
                  introduction?.right_section &&
                  introduction?.right_section.length > 0
                    ? introduction.right_section[0].main_image[0].url
                    : ''
                "
                alt="Logo"
              />
            </div>
            <div class="img-content">
              <h4>
                {{
                  introduction &&
                  introduction?.right_section &&
                  introduction?.right_section.length > 0
                    ? introduction.right_section[0].heading
                    : ""
                }}
              </h4>
              <div
                v-html="
                  introduction &&
                  introduction?.right_section &&
                  introduction?.right_section.length > 0
                    ? introduction.right_section[0].text
                    : ''
                "
              ></div>
              <button class="get-started">
                {{
                  introduction &&
                  introduction?.right_section &&
                  introduction?.right_section.length > 0
                    ? introduction.right_section[0].button_text
                    : ""
                }}
              </button>
            </div>
          </div> -->

          <div class="result-detail">
            <div class="left">
              <h4>
                {{
                  introduction &&
                    introduction?.right_section &&
                    introduction?.right_section.length > 0
                    ? introduction.right_section[1].heading
                    : ""
                }}
              </h4>
              <div v-html="introduction &&
                introduction?.right_section &&
                introduction?.right_section.length > 0
                ? introduction.right_section[1].text
                : ''
                "></div>
              <router-link to="/vikings/results" class="load-btn">{{
                introduction &&
                  introduction?.right_section &&
                  introduction?.right_section.length > 0
                  ? introduction.right_section[1].button_text
                  : ""
              }}</router-link>
            </div>
            <div class="percentage-area">
              <div class="progress-wrapper">
                <DoughnutChart :chart-data="chartData" ChartColor="rgb(51, 119, 255)"
                  :centerTitle="vikingResult.percentile" centerSubtitle="" :options="options" chartWidth="100%"
                  chartHeight="100%" class="percentage-area-rowx" />
                <!-- <svg class="progress-circle" viewBox="0 0 100 100">
                  <circle ref="circle" cx="50" cy="50" r="40"></circle>
                </svg>
                <svg class="progress-bar" viewBox="0 0 100 100" :style="{ 'stroke-dasharray': ((vikingResult.percentile/100) * 250) + ' 1000' }">
                  <circle cx="50" cy="50" r="40"></circle>
                </svg>
                <text class="progress-text" x="50" y="50">
                  <b>{{ vikingResult.percentile }}</b
                  ><span>(Viking Index)</span>
                </text> -->
              </div>
            </div>
          </div>

          <div class="population-group">
            <h4>
              {{
                introduction &&
                  introduction?.right_section &&
                  introduction?.right_section.length > 0
                  ? introduction.right_section[2].heading
                  : ""
              }}
            </h4>
            <div v-html="introduction &&
              introduction?.right_section &&
              introduction?.right_section.length > 0
              ? introduction.right_section[2].text
              : ''
              "></div>
            <img :src="introduction &&
              introduction?.right_section &&
              introduction?.right_section.length > 0
              ? introduction.right_section[2].main_image[0].url
              : ''
              " />
            <router-link to="/vikings/maps" class="load-btn m-auto">{{
              introduction &&
                introduction?.right_section &&
                introduction?.right_section.length > 0
                ? introduction.right_section[2].button_text
                : ""
            }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../styles/pages/vikings.scss";
import { ref } from "vue";
import DoughnutChart from "@/components/charts/Doughnut.vue";
import { getVikingIntroduction } from "@/services/vikings";
export default {
  name: "AncestrySection",
  props: { vikingResult: Object },
  components: { DoughnutChart },
  setup() {
    const loadingStatus = ref("loading");
    const options = {
      cutout: "70%",
      radius: "100%",
      responsive: true,
    };
    const introduction = ref({});
    getVikingIntroduction()
      .then((res) => {
        introduction.value = res;
        loadingStatus.value = "loaded";
      })
      .catch((error) => {
        console.error("Error fetching introduction:", error);
        loadingStatus.value = "loadingFailed";
      });
    return { loadingStatus, introduction, options };
  },
  computed: {
    chartData() {
      return {
        datasets: [
          {
            data: [this.vikingResult.percentile, 100 - this.vikingResult.percentile],
            backgroundColor: ["rgb(51, 119, 255)", "#ddd"],
          },
        ],
        labels: [],
      };
    },
  },
};
</script>
